import {Link, redirect, useLoaderData, useParams} from "react-router-dom";
import HttpRequest from "../../services/Request";
import TournamentComponent from '../../components/Tournament'
import UserBox from "../../components/UserBox";
import Cookies from "js-cookie";
import {Image} from "antd";
import BackButton from "../../components/BackButton";

const Step = () => {
    const {tournament, contest} = useLoaderData();
    const getPartFile = (name) => contest.parts.find(c => c.name === name)?.file ?? null;
    const description_url = getPartFile('d');
    const errors_url = getPartFile('e');
    const tools_url = getPartFile('t');
    const total_url = getPartFile('total');
    const animation_url = getPartFile('a');
    const params = useParams();
    return <div>
        <BackButton src={`/tournament/${params.id}/steps`} />
        <div className="flex items-center">
            <TournamentComponent tournament={tournament}/>
        </div>
        <div className="flex items-center mt-2">
            <div className="flex flex-wrap w-[97%]  md:w-[90%] rounded-[15px]  mx-auto mt-1 md:mt-0 md:mb-2 p-2 py-5">
                <div className="w-[80%] md:w-[27%] md:mt-5 text-center p-3 mx-auto shadow mt-3 bg-gray2 text-orange">
                    {contest.name}
                </div>
            </div>
        </div>
        <div className="mt-2">
            <div
                className="flex flex-wrap w-[97%] md:w-[90%] rounded-[15px] mx-auto mt-1 md:mt-0 md:mb-2 bg-white p-2 py-5">
                <a href={description_url}
                   className="w-[80%] md:w-[22%] md:mt-5 text-center p-3  mx-auto  shadow mt-3 bg-gray2 text-white font-bold">
                    <img src="/icons/step-description.png" className={`inline mx-2`} alt=""/>
                    <span className="text-[18px]">شرح مسابقه</span>
                </a>
                <a href={errors_url}
                   className="w-[80%] md:w-[22%] md:mt-5 text-center p-3  mx-auto  shadow mt-3 bg-gray2 text-white font-bold">
                    <img src="/icons/step-errors.png" className={`inline mx-2`} alt=""/>
                    <span className="text-[18px]">خطاهای مسابقه</span>
                </a>
                <a href={tools_url}
                   className="w-[80%] md:w-[22%] md:mt-5 text-center p-3  mx-auto  shadow mt-3 bg-gray2 text-white font-bold">
                    <img src="/icons/step-tools.png" className={`inline mx-2`} alt=""/>
                    <span className="text-[18px]">تجهیزات مورد نیاز</span>
                </a>
            </div>
            {(total_url || animation_url) && <div
                className="flex flex-wrap w-[97%] md:w-[90%] rounded-[15px] mx-auto mt-1 md:mt-0 md:mb-2 bg-white p-2 py-5">
                <div className="flex flex-wrap">
                    {total_url && <div className={`w-[80%] md:w-[45%] mt-5 mx-auto shadow`}>
                        <Image src={total_url} width={`100%`} alt=""/>
                    </div>}

                    {animation_url && <video className={`w-[80%] md:w-[45%] mt-5 mx-auto shadow`} controls>
                        <source
                            src={animation_url}/>
                    </video>}
                </div>
            </div>}

        </div>
    </div>
}

export default Step

export async function StepPageLoader({params}) {
    let data = []
    try {
        await HttpRequest(`${process.env.REACT_APP_DOMAIN}/user/tournament/${params.id}/step/${params.step_id}`, (res) => {
                data = res.data;
            }, 'get', [], (err) => {
                let error = new Error();
                error.status = err.response.status
                throw error
            }
        )
    } catch (err) {
        if (err.status === 401) {
            Cookies.remove('access_token')
            return redirect('/login')
        }
    }
    return data;
}